<div class="row category-title">
  <section>
    <span>{{categoryTitle}}</span>
    @if (categoryType=='mostpopular') {
      <div>
        <p>The most popular posters, patient education and office materials.</p>
      </div>
    }
    @if (!categoryTitle?.includes('popular')) {
      <div>
        <p></p>
      </div>
    }
  </section>
</div>
<div class="row patient-three-row position-relative">
  @if (!catalogsList.length) {
    <mat-spinner class="spinner absolute top200" mode="indeterminate" diameter="100"></mat-spinner>
  }
  @for (catalog of catalogsList|slice:trimStart:trimEnd; track catalog) {
    @if (loggedInDevice == 'others') {
<div class="
        col-xs-12 col-sm-12 col-md-6 col-lg-4
        patient-card
        checkout-details
        desktop-view
      "
        >
        <section class="patient-img">
          <img [src]="getImage(catalog.images)" alt="" class="flu-poster" />
        </section>
        @if (catalog && catalog.images) {
          <span (click)="openNewModalPopup(catalog.images)">
            <img [src]="'/icons/'+baseSiteId+'/fullscreen.svg'" class="fullscreen" alt="full" />
          </span>
        }
        <p class="patient-title-style" innerHtml="{{ catalog.name }}"></p>
        <div class="patient_edu_desc">
          <p class="patient_edu_desc_style">
            {{catalog.description}}
          </p>
        </div>
        <div class="row numb-img">
          @if (catalog.downloadMedia && catalog?.downloadable ) {
            <div class="col-xs-6 col-sm-6 col-md-6 p0 name-code">
              <p class="poster-numb">
                <span class="poster-code"> {{ catalog.code }}</span> | {{ catalog?.downloadedMediaType }}
              </p>
            </div>
          }
          @if (!catalog.downloadMedia || !catalog?.downloadable) {
            <div>
              <p class="poster-numb">
                <span class="poster-code"> {{ catalog.code }}</span>
              </p>
            </div>
          }
          @if (catalog.downloadMedia && catalog?.downloadable) {
            <div class="col-xs-6 col-sm-6 col-md-6 p0 download-sec">
              <img [src]="'/icons/'+baseSiteId+'/download-icon.svg'" alt="download" />
          <a (click)="
              downloadFile(catalog.downloadMedia, catalog.code)
            ">Download</a>
            </div>
          }
        </div>
        @if (userDetails == undefined) {
          <section class="plpbutton btn-align">
            @if (!catalog?.unavailable) {
              <button type="button" class="btn btn-primary three" (click)="goToLogin()">
                {{'patientEducation.loginToRequest'|cxTranslate}}
              </button>
            }
          </section>
        }
        @if (userDetails !== undefined) {
          <section class="plpbutton authuser-align">
            @if (catalog?.unavailable ==false && catalog?.orderable) {
              <div class="row">
                <div class="col-md-6">
                  <span class="unit-style">{{'units'}}</span>
                  <section class="unit-area">
                    <span class="disabled" aria-hidden="true" id="{{'minusIcon'+catalog?.code}}">
                      <img src="/icons/{{baseSiteId}}/less_new.svg" id="{{'unitMinus'+catalog?.code}}"
                        class="disabled-img" alt="minus_icon"
                        (click)="performQuantityComputation(2,catalog?.code,catalog?.postersQuantityPerUnit,catalog.unit,catalog)">
                      <img src="/icons/{{baseSiteId}}/less-disable_new.svg"
                        id="{{'unitMinusDisable'+catalog?.code}}" alt="" class="disablemore">
                    </span>
              <input type="number" class="prod-quantity text-center" [value]="unitDefaultValue" (keyup)="performQuantityComputation(null,catalog?.code,
              catalog?.postersQuantityPerUnit,catalog.unit,catalog)" id="{{'prodQuantity'+catalog?.code}}"
                      maxlength="4" [ngbPopover]=popOverLimit placement="top" #popOver="ngbPopover" triggers="manual"
                      popoverClass="savedordermini-popover" appNoMouseScroll />
                    <span class="pointer-style" aria-hidden="true" id="{{'plusIcon'+catalog?.code}}">
                      <img src="/icons/{{baseSiteId}}/more.svg" id="{{'unitPlus'+catalog?.code}}"
                        alt="plus_icon 1"
                        (click)="performQuantityComputation(1,catalog?.code,catalog?.postersQuantityPerUnit,catalog.unit,catalog)">
                      <img class="disabled-img" src="/icons/{{baseSiteId}}/more-disable.svg"
                        id="{{'unitPlusDisable'+catalog?.code}}" alt="">
                    </span>
                    <section class="dosessection" id="{{'noOfDoses'+catalog?.code}}">
                      {{catalog?.postersQuantityPerUnit ? unitDefaultValue*catalog?.postersQuantityPerUnit :
                    unitDefaultValue}} {{catalog.unit}}</section>
                  </section>
                </div>
                <div class="col-md-6">
                  <button type="button" id="{{'btn'+catalog?.code}}" class="btn-primary btn-override"
                    (click)="addRequestItem(catalog,unitDefaultValue,popOver,1)">
                    {{'patientEducation.requestItem'|cxTranslate}}
                  </button>
                </div>
              </div>
            }
            @if (catalog?.unavailable ==true && (catalog?.orderable || !catalog?.orderable)) {
              <div class="ml-2 unavailable-style"
                >
                {{'patientEducation.productUnavailableMsg'|cxTranslate}}
              </div>
            }
          </section>
        }
      </div>
    }
    @if (loggedInDevice == 'mobile') {
      <div
    class="
        col-xs-12 col-sm-12 col-md-12
        patient-card
        checkout-details
        tab-view
      ">
        <section class="patient-img">
          <img [src]="getImage(catalog.images)" alt="" class="flu-poster" />
        </section>
        @if (catalog && catalog.images) {
          <span (click)="openNewModalPopup(catalog.images)">
            <img [src]="'/icons/'+baseSiteId+'/fullscreen.svg'" class="fullscreen" alt="full" />
          </span>
        }
        <p class="patient-title-style" innerHtml="{{ catalog.name }}"></p>
        <div class="patient_edu_desc">
          <p class="patient_edu_desc_style">
            {{catalog.description}}
          </p>
        </div>
        <div class="row numb-img">
          @if (catalog.downloadMedia && catalog?.downloadable) {
            <div class="col-xs-6 col-sm-6 col-md-6 p0 name-code">
              <p class="poster-numb">
                <span class="poster-code"> {{ catalog.code }}</span> | {{ catalog?.downloadedMediaType }}
              </p>
            </div>
          }
          @if (!catalog.downloadMedia || !catalog?.downloadable) {
            <div>
              <p class="poster-numb">
                <span class="poster-code"> {{ catalog.code }}</span>
              </p>
            </div>
          }
          @if (catalog?.downloadMedia && catalog?.downloadable) {
            <div class="col-xs-6 col-sm-6 col-md-6 p0 download-sec">
              <img [src]="'/icons/'+baseSiteId+'/download-icon.svg'" alt="download" />
          <a (click)="
              downloadFile(catalog?.downloadMedia, catalog.code)
            ">Download</a>
            </div>
          }
        </div>
        @if (userDetails == undefined) {
          <section class="plpbutton btn-align">
            @if (!catalog?.unavailable) {
              <button type="button" class="btn btn-primary three" (click)="goToLogin()">
                {{'patientEducation.loginToRequest'|cxTranslate}}
              </button>
            }
          </section>
        }
        @if (userDetails !== undefined) {
          <section class="plpbutton authuser-align">
            @if (catalog?.unavailable ==false && catalog?.orderable) {
              <div class="row text-left">
                <div class="text-center">
                  <span class="unit-style">{{'units'}}</span>
                  <section class="unit-area">
                    <span class="disabled" aria-hidden="true" id="{{'minusIcon'+catalog?.code}}">
                      <img src="/icons/{{baseSiteId}}/less_new.svg" id="{{'unitMinus'+catalog?.code}}"
                        class="disabled-img" alt="minus_icon"
                        (click)="performQuantityComputation(2,catalog?.code,catalog?.postersQuantityPerUnit,'doses',catalog)">
                      <img src="/icons/{{baseSiteId}}/less-disable_new.svg"
                        id="{{'unitMinusDisable'+catalog?.code}}" alt="" class="disablemore">
                    </span>
              <input type="number" class="prod-quantity text-center" [value]="unitDefaultValue" (keyup)="performQuantityComputation(null,catalog?.code,
                catalog?.postersQuantityPerUnit,catalog.unit,catalog)" id="{{'prodQuantity'+catalog?.code}}"
                      maxlength="4" [ngbPopover]=popOverLimit placement="top" #popOver="ngbPopover" triggers="manual"
                      popoverClass="savedordermini-popover" appNoMouseScroll />
                    <span class="pointer-style" aria-hidden="true" id="{{'plusIcon'+catalog?.code}}">
                      <img
                        (click)="performQuantityComputation(1,catalog?.code,catalog?.postersQuantityPerUnit,catalog.unit,catalog)"
                        [src]="'/icons/'+baseSiteId+'/more.svg'" id="{{'unitPlus'+catalog?.code}}"
                        alt="plus_icon 2">
                      <img class="disabled-img" src="/icons/more-disable.svg"
                        id="{{'unitPlusDisable'+catalog?.code}}" alt="">
                    </span>
                    <section class="dosessection" id="{{'noOfDoses'+catalog?.code}}">
                      {{catalog?.postersQuantityPerUnit ? unitDefaultValue*catalog?.postersQuantityPerUnit :
                    unitDefaultValue}} {{catalog.unit}}</section>
                  </section>
                </div>
                <div class="requestItem-mob">
                  <button type="button" id="{{'btn'+catalog?.code}}" class="btn-primary"
                    (click)="addRequestItem(catalog,unitDefaultValue,popOver,1)">
                    {{'patientEducation.requestItem'|cxTranslate}}
                  </button>
                </div>
              </div>
            }
            @if (catalog?.unavailable ==true && (catalog?.orderable || !catalog?.orderable)) {
              <div class="ml-2 unavailable-style"
                >
                {{'patientEducation.productUnavailableMsg'|cxTranslate}}
              </div>
            }
          </section>
        }
      </div>
    }
  }
</div>
@if (tempCatalogsList.length>0) {
  <div class="pagination-row mt-4">
    <p>
      {{ "ordersList.showing" | cxTranslate }}
      <span class="no_rec">{{ pageRange }}</span>&nbsp;{{ "ordersList.of" | cxTranslate }}
      <span class="no_rec">{{ totalOrders }}</span>&nbsp;{{ "ordersList.products" | cxTranslate }}
    </p>
    <p class="align-btns">
      <button [disabled]="curPage == 1" (click)="getCurrentPage('prev')" class="pagination-btns mr-1">
        <span class="chevronIconWhite prev">
        < </span>
      </button>
    <button class="pagination-btns" [disabled]="
            curPage >= totalOrders / pageSize ||
            (totalOrders === 0 && pageSize === 0)
          " (click)="getCurrentPage('next')">
        <span class="chevronIconWhite next"> > </span>
      </button>
    </p>
    <p>
      <span>{{ "ordersList.page" | cxTranslate }} {{ curPage }}
      {{ "ordersList.of" | cxTranslate }} {{ numberOfPages() }}</span>
    </p>
  </div>
}
<ng-template #popOverLimit>
  <div><img class="img-style" src="/icons/warning_red.png" alt="download" /><span> Limit
  {{productQuantity}} units</span>
</div>
</ng-template>
